"use client";

import { baseCardCls, shadowCls } from "@/components/platform/style";
import { cn } from "@/lib/utils";

interface HomeEventListSkeletonProps {
    ifSport?: boolean;
}

function SkeletonBlock( { className }: { className: string } ) {
    return <div className={cn( "rounded skeleton", className )} />;
}

function SkeletonButton() {
    return <SkeletonBlock className="h-11 flex-1" />;
}

function NormalEventCardSkeleton() {
    return (
        <div className={cn( baseCardCls, shadowCls )}>
            <div className="flex items-center gap-2">
                <SkeletonBlock className="size-[38px] shrink-0" />

                <div className="flex-1 min-w-0 flex items-center justify-between gap-3">
                    <div className="flex-1 space-y-1.5">
                        <SkeletonBlock className="h-4 w-full" />
                        <SkeletonBlock className="h-4 w-4/5" />
                    </div>
                    <SkeletonBlock className="h-6 w-10 shrink-0" />
                </div>
            </div>

            <div className="mt-4 mb-3 flex gap-2">
                <SkeletonButton />
                <SkeletonButton />
            </div>

            <div className="font-medium flex gap-2 items-center text-t3 text-xs border-t border-stroke pt-2 -mx-3 px-4 -mb-1">
                <div className="flex items-center gap-1">
                    <SkeletonBlock className="size-3 rounded-sm" />
                    <SkeletonBlock className="h-3 w-8" />
                </div>
                <div className="ml-auto size-7 rounded-full skeleton" />
            </div>
        </div>
    );
}

function SportEventCardSkeleton() {
    return (
        <div className={cn( baseCardCls, shadowCls )}>
            <div className="mb-3 flex items-center justify-between gap-4">
                <SkeletonBlock className="h-5 flex-1" />
                <SkeletonBlock className="h-8 w-[126px]" />
            </div>

            {[ 0, 1 ].map( ( index ) => (
                <div key={index} className="mb-2 flex items-center gap-2">
                    <SkeletonBlock className="size-5 shrink-0" />
                    <SkeletonBlock className="h-4 flex-1" />
                    <SkeletonBlock className="h-5 w-10" />
                </div>
            ) )}

            <div className="mb-3 mt-4 flex gap-2">
                <SkeletonButton />
                <SkeletonButton />
            </div>

            <div className="font-medium flex gap-2 items-center text-t3 text-xs border-t border-stroke pt-2 -mx-3 px-4 -mb-1">
                <SkeletonBlock className="h-3 w-20" />
                <div className="ml-auto size-7 rounded-full skeleton" />
            </div>
        </div>
    );
}

export function HomeEventListSkeleton( { ifSport = false }: HomeEventListSkeletonProps ) {
    return (
        <div className="mb-[30px] mt-3 flex flex-col gap-3">
            {Array.from( { length: 3 } ).map( (
                _,
                index,
            ) => ( ifSport ? <SportEventCardSkeleton key={index} /> : <NormalEventCardSkeleton key={index} /> ) )}
        </div>
    );
}
